<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
export default {
  name: "FieldProperties",
  components: {},
  data: function () {
    return {
      tablekey: 0,
      chooseindex: 0,
      taballData: [
        {
          label: "通用",
        },
        {
          label: "科目余额表",
        },
        {
          label: "增值税发票",
        },
        {
          label: "增值税发票",
        },
      ],
      headData: getdata().headData,
      tableData: [{}],
    };
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
